module.exports = __webpack_public_path__ + "static/media/addon-ai.58b9f551.png";


//////////////////
// WEBPACK FOOTER
// ./src/theme/assets/addon-ai.png
// module id = 754
// module chunks = 0